import clsx from 'clsx'
import styled from 'styled-components'

const Badge = styled.span`
  width: max-content;
  height: max-content;

  & ._bg-red {
    background-color: var(--red);
  }
`
type CommunityListBadgeProps = {
  className?: string
}

export const CommunityListBadge = ({ className }: CommunityListBadgeProps) => {
  return (
    <Badge className='_d-block'>
      <span className={clsx('_d-block _w-2 _h-2 _bg-red _rounded-circle', className)} />
    </Badge>
  )
}
